var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { HTTPServer } from '@/common/js/ajax.js';
import tool from '@/common/js/tool.js';
const IMAGE_TYPE_LIST = ['image/jpeg', 'image/png', 'image/bmp'];
const IMAGE_EXT_REG = /\.(jpe?g|png|bmp)$/i;
let AiImageTextRecognitionModal = class AiImageTextRecognitionModal extends Vue {
    constructor() {
        super(...arguments);
        this.dialogVisible = false;
        this.recognitionText = '';
        this.currentProperty = null;
        this.currentBean = '';
        this.imageList = [];
        this.isDragover = false;
        this.recognitionLoading = false;
        this.recognitionRequestId = 0;
        this.picUrl = localStorage.getItem('pictureAttachmentDomain') || '';
        this.token = '';
    }
    created() {
        this.token = this.getToken();
        this.$bus.off('open-ai-image-text-recognition-modal', this.openModal);
        this.$bus.on('open-ai-image-text-recognition-modal', this.openModal);
    }
    get uploadTip() {
        return this.languageUploadTip() || this.defaultUploadTip;
    }
    get defaultUploadTip() {
        var _a, _b;
        return `请上传图片，最多可上传${(_b = (_a = this.currentProperty) === null || _a === void 0 ? void 0 : _a.field) === null || _b === void 0 ? void 0 : _b.maxCount}张，支持jpg/jpeg/png/bmp格式`;
    }
    get maxCount() {
        var _a, _b;
        return Number((_b = (_a = this.currentProperty) === null || _a === void 0 ? void 0 : _a.field) === null || _b === void 0 ? void 0 : _b.maxCount);
    }
    get maxSize() {
        var _a, _b;
        const maxSize = Number((_b = (_a = this.currentProperty) === null || _a === void 0 ? void 0 : _a.field) === null || _b === void 0 ? void 0 : _b.maxSize);
        return Number.isFinite(maxSize) && maxSize > 0 ? maxSize : 10;
    }
    get isUploadDisabled() {
        return this.imageList.length >= this.maxCount;
    }
    beforeDestroy() {
        this.$bus.off('open-ai-image-text-recognition-modal', this.openModal);
    }
    openModal(payload) {
        const modalPayload = this.normalizeOpenPayload(payload);
        this.currentProperty = modalPayload.property;
        this.currentBean = modalPayload.bean || '';
        this.resetForm();
        this.applySource(modalPayload.source);
        this.dialogVisible = true;
    }
    handleClose() {
        this.recognitionRequestId += 1;
        this.recognitionLoading = false;
        this.resetForm();
        this.currentBean = '';
    }
    triggerUpload() {
        if (this.isUploadDisabled) {
            this.$tfMessage.warning(`最多可上传${this.maxCount}张图片`);
            return;
        }
        const input = this.$refs.imageInput;
        input === null || input === void 0 ? void 0 : input.click();
    }
    handleImageChange(event) {
        const input = event.target;
        const files = Array.from(input.files || []);
        if (!files.length)
            return;
        this.handleUploadXss(files);
        input.value = '';
    }
    handleDrop(event) {
        var _a;
        this.isDragover = false;
        if (this.isUploadDisabled) {
            this.$tfMessage.warning(`最多可上传${this.maxCount}张图片`);
            return;
        }
        const files = Array.from(((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files) || []);
        if (!files.length)
            return;
        this.handleUploadXss(files);
    }
    handleDragenter() {
        if (this.isUploadDisabled)
            return;
        this.isDragover = true;
    }
    handleDragleave() {
        this.isDragover = false;
    }
    handleUploadXss(files) {
        tool.handleUploadXss(files, (status) => {
            if (status) {
                this.$tfMessage.error(status);
            }
            else {
                this.uploadFile(files);
            }
        });
    }
    uploadFile(files) {
        var _a;
        const validFiles = this.getValidFiles(files);
        if (!validFiles.length)
            return;
        const field = (_a = this.currentProperty) === null || _a === void 0 ? void 0 : _a.field;
        if (field === null || field === void 0 ? void 0 : field.is_compress) {
            tool.pictureCompress(validFiles, field.compress_ratio, (list) => {
                this.uploadByFormData(list);
            });
            return;
        }
        this.uploadByFormData(validFiles);
    }
    getValidFiles(files) {
        const validFiles = [];
        const restCount = this.maxCount - this.imageList.length;
        if (files.length > restCount) {
            this.$tfMessage.warning(`最多可上传${this.maxCount}张图片`);
        }
        files.slice(0, restCount).forEach(file => {
            if (!this.isValidImageType(file)) {
                this.$tfMessage.warning('仅支持jpg/jpeg/png/bmp格式图片');
                return;
            }
            if (file.size > this.maxSize * 1024 * 1024) {
                this.$tfMessage.warning(`每张图片限制${this.maxSize}M`);
                return;
            }
            validFiles.push(file);
        });
        return validFiles;
    }
    uploadByFormData(files) {
        const formdata = new FormData();
        files.forEach((file, index) => {
            formdata.append(`file${index}`, file);
        });
        formdata.append('bean', this.currentBean);
        HTTPServer.customUpload(formdata, 'Loading').then((res) => {
            this.imageList = this.imageList.concat(res.map((image, index) => (Object.assign(Object.assign({}, image), { id: `${image.file_url || image.file_name}_${Date.now()}_${index}` }))));
        });
    }
    isValidImageType(file) {
        return IMAGE_TYPE_LIST.includes(file.type) || IMAGE_EXT_REG.test(file.name);
    }
    removeImage(index) {
        this.imageList.splice(index, 1);
    }
    getImageUrl(image) {
        return `${this.picUrl}${image.file_url}&TOKEN=${this.token}`;
    }
    openPreview(index) {
        const picsList = this.imageList.map(image => (Object.assign(Object.assign({}, image), { fileForm: true, file_url: this.appendToken(image.file_url) })));
        const file = Object.assign(Object.assign({}, picsList[index]), { isInit: true, isPicsList: true, currtagetImgIndex: index, picsList });
        this.$bus.emit('file-preview', file);
    }
    appendToken(fileUrl) {
        if (!this.token || fileUrl.includes('TOKEN='))
            return fileUrl;
        return `${fileUrl}&TOKEN=${this.token}`;
    }
    startRecognition() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.recognitionLoading)
                return;
            const text = this.recognitionText.trim();
            if (!text && this.imageList.length === 0) {
                this.$tfMessage.warning('请填写识别文字或上传识别图片');
                return;
            }
            if (text && this.imageList.length > 0) {
                this.$tfMessage.warning('文字和图片仅保留1处即可，请删除1处');
                return;
            }
            const requestId = Date.now();
            this.recognitionRequestId = requestId;
            this.recognitionLoading = true;
            try {
                const source = {
                    text,
                    images: this.imageList
                };
                const res = yield this.requestRecognition(source);
                if (requestId !== this.recognitionRequestId)
                    return;
                if (!res.success || !res.data) {
                    this.$tfMessage.warning(res.message || '识别失败，请重试');
                    return;
                }
                const payload = {
                    content: res.data,
                    source
                };
                this.$bus.emit('ai-image-text-recognition-source', payload);
                this.dialogVisible = false;
            }
            catch (error) {
                if (requestId !== this.recognitionRequestId)
                    return;
                this.$tfMessage.warning(this.getRequestErrorMessage(error));
            }
            finally {
                if (requestId === this.recognitionRequestId) {
                    this.recognitionLoading = false;
                }
            }
        });
    }
    requestRecognition(source) {
        return __awaiter(this, void 0, void 0, function* () {
            const mapping = (yield HTTPServer.getAccidentCarInfo({
                bean: this.currentBean,
                text: source.text,
                images: source.images
            }));
            if (!Object.keys(mapping).length) {
                return {
                    success: false,
                    message: '未识别到可回填的数据'
                };
            }
            return {
                success: true,
                data: mapping
            };
        });
    }
    getRequestErrorMessage(error) {
        return (error === null || error === void 0 ? void 0 : error.describe) || (error === null || error === void 0 ? void 0 : error.message) || '识别失败，请重试';
    }
    resetForm() {
        this.recognitionText = '';
        this.imageList = [];
        this.isDragover = false;
        const input = this.$refs.imageInput;
        if (input)
            input.value = '';
    }
    normalizeOpenPayload(payload) {
        if (payload.property) {
            return payload;
        }
        return {
            property: payload,
            bean: ''
        };
    }
    applySource(source) {
        if (!source)
            return;
        this.recognitionText = source.text || '';
        this.imageList = Array.isArray(source.images)
            ? source.images.map((image, index) => (Object.assign(Object.assign({}, image), { id: image.id || `${image.file_url || image.file_name}_${Date.now()}_${index}` })))
            : [];
    }
    languageUploadTip() {
        var _a, _b;
        const uploadTip = (_b = (_a = this.currentProperty) === null || _a === void 0 ? void 0 : _a.field) === null || _b === void 0 ? void 0 : _b.fieldDescribe;
        if (!uploadTip)
            return '';
        if (typeof uploadTip !== 'string') {
            return this.formatUploadTip(uploadTip.language[this.$i18n.locale] || '');
        }
        return this.formatUploadTip(uploadTip);
    }
    formatUploadTip(value) {
        return value
            .replace(/<[^>]+>/g, '')
            .replace(/&nbsp;/g, ' ')
            .trim();
    }
    getToken() {
        try {
            return JSON.parse(localStorage.getItem('requestHeader') || '{}').TOKEN || '';
        }
        catch (error) {
            return '';
        }
    }
};
AiImageTextRecognitionModal = __decorate([
    Component({
        name: 'AiImageTextRecognitionModal'
    })
], AiImageTextRecognitionModal);
export default AiImageTextRecognitionModal;
